import { render, staticRenderFns } from "./CustomerGrowthWidget.vue?vue&type=template&id=001521b8&scoped=true"
import script from "./CustomerGrowthWidget.vue?vue&type=script&lang=ts"
export * from "./CustomerGrowthWidget.vue?vue&type=script&lang=ts"
import style0 from "./CustomerGrowthWidget.vue?vue&type=style&index=0&id=001521b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001521b8",
  null
  
)

export default component.exports